import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { PhonePipe } from './pipes/phone';
import { XmCurrencyPipe } from './pipes/currency';
import { IMEIPipe } from './pipes/imei';
import { StripHtml } from './pipes/strip-html';
import { ConvertUnitPipe } from './pipes/unit';
import { KeysPipe } from './pipes/keys';
import { SafeHtmlPipe } from './pipes/html';
import { XmContentChange } from './pipes/contentChange';
import { TruncatePipe } from './pipes/truncate';
import { XmEnvLinkPipe } from './pipes/env-link';

import { XmMask } from './directives/mask';
import { XmButtonClick } from './directives/button';
import { XmAriaDescribedBy } from './directives/aria-describedby';
import { XmAriaInvalid } from './directives/aria-invalid';
import { XmAriaFocus } from './directives/aria-focus';
import { XmAriaHidden } from './directives/aria-hidden';
import { XmAriaDisabled } from './directives/aria-disabled';
import { XmRadioControl } from './directives/radio';

import { XmMediaImageComponent } from './media/image/image';
import { XmResponsiveImageComponent } from './media/responsive-image/responsive-image';
import { XmRadioComponent } from './radio/radio';
import { XmPaymentAmountSelectorComponent } from './payment-amount-selector/payment-amount-selector';
import { CmsTextComponent } from './cms-text/text';
import { XmCmsActionComponent } from './cms-action/cms-action';
import { XmExpandableComponent } from './expandable/expandable';
import { XmValidationComponent } from './validation/validation';
import { XmQuantityControlComponent } from './quantity/quantity';
import { XmEmptyComponent } from './empty/empty';
import { XmDropdownComponent } from './dropdown/dropdown';
import { XmSlideUpComponent } from './animations/slide-up/slide-up';
import { XmAutoCompleteComponent } from './autocomplete/autocomplete';
import { XmSchemaComponent } from './schema/schema';
import { XmDecoratedTextComponent } from './decorated-text/decorated-text';
import { XmCardReview } from './card-review/card-review';
import { CardTypeService } from './services/card-type';
import { XmSharedProgressBarComponent } from './progress-bar/progress-bar';
import { CurrencyInputService } from './services/currency-input';
import { XmCheckboxComponent } from './checkbox/checkbox';
import { XmSearch } from './search/search';
import { XmTravelRateDetails } from './travel-rate-details/travel-rate-details';
import { XmCallRateDetails } from './call-rates-details/call-rates-details';
import { XmPaymentSummaryComponent } from './payment-summary/payment-summary';
import { SessionUtil } from '../quickpay/shared/services/session-util';
import { XmPromiseBtn } from './directives/promise-button-loader';
import { XmCheckboxGroupComponent } from './checkbox-group/checkbox-group';
import { XmCheckboxDirective } from './directives/aria-checked';
import { XmEscKey } from './directives/esc-key.directive';
import { LoaderOverlayComponent } from './loader-overlay/loader-overlay';
import { XmSharedPillComponent } from './pill/pill';
import { XmUserRoleComponent } from 'shared/user-roles/user-roles';

@NgModule({
    declarations: [
        PhonePipe,
        IMEIPipe,
        XmContentChange,
        XmEnvLinkPipe,
        ConvertUnitPipe,
        KeysPipe,
        SafeHtmlPipe,
        StripHtml,
        XmCurrencyPipe,
        TruncatePipe,
        XmMask,
        XmButtonClick,
        XmAriaDescribedBy,
        XmAriaInvalid,
        XmAriaFocus,
        XmAriaHidden,
        XmAriaDisabled,
        XmRadioControl,
        XmRadioComponent,
        XmCheckboxComponent,
        XmMediaImageComponent,
        XmResponsiveImageComponent,
        CmsTextComponent,
        XmDecoratedTextComponent,
        XmCmsActionComponent,
        XmExpandableComponent,
        XmValidationComponent,
        XmQuantityControlComponent,
        XmEmptyComponent,
        XmDropdownComponent,
        XmSlideUpComponent,
        XmAutoCompleteComponent,
        XmSchemaComponent,
        XmPaymentAmountSelectorComponent,
        XmCardReview,
        XmSharedProgressBarComponent,
        XmSearch,
        XmTravelRateDetails,
        XmCallRateDetails,
        XmPaymentSummaryComponent,
        XmPromiseBtn,
        XmCheckboxGroupComponent,
        XmCheckboxDirective,
        XmEscKey,
        LoaderOverlayComponent,
        XmSharedPillComponent,
        XmUserRoleComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UIRouterModule,
        DecimalPipe,
        PhonePipe,
        XmCurrencyPipe,
        IMEIPipe,
        XmContentChange,
        XmEnvLinkPipe,
        ConvertUnitPipe,
        KeysPipe,
        SafeHtmlPipe,
        StripHtml,
        TruncatePipe,
        XmMask,
        XmButtonClick,
        XmAriaDescribedBy,
        XmAriaInvalid,
        XmAriaFocus,
        XmAriaHidden,
        XmAriaDisabled,
        XmRadioControl,
        XmRadioComponent,
        XmCheckboxComponent,
        XmMediaImageComponent,
        XmResponsiveImageComponent,
        CmsTextComponent,
        XmDecoratedTextComponent,
        XmCmsActionComponent,
        XmExpandableComponent,
        XmValidationComponent,
        FormsModule,
        ReactiveFormsModule,
        XmEmptyComponent,
        XmQuantityControlComponent,
        XmDropdownComponent,
        XmSlideUpComponent,
        XmAutoCompleteComponent,
        XmSchemaComponent,
        XmPaymentAmountSelectorComponent,
        XmCardReview,
        XmSharedProgressBarComponent,
        XmSearch,
        XmTravelRateDetails,
        XmCallRateDetails,
        XmPaymentSummaryComponent,
        XmPromiseBtn,
        XmCheckboxGroupComponent,
        XmCheckboxDirective,
        XmEscKey,
        LoaderOverlayComponent,
        XmSharedPillComponent,
        XmUserRoleComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UIRouterModule
    ],
    providers: [
        DatePipe,
        CurrencyPipe,
        PhonePipe,
        XmCurrencyPipe,
        XmEnvLinkPipe,
        StripHtml,
        TruncatePipe,
        CardTypeService,
        CurrencyInputService,
        SessionUtil
    ]
})
export class SharedModule {}
